import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";
const faqData = [
    {
        question:
            "How do I know if custom software is the right choice for my business?",
        answer:
            "Custom software makes sense when your workflows are too specific for standard tools, or when multiple systems need to work together more effectively.",
    },
    {
        question:
            "Can you work with our existing software and systems?",
        answer:
            "Yes. We integrate seamlessly with your current systems to enhance functionality, improve efficiency, and ensure scalability.",
    },
    {
        question:
            "Do projects always need to start with a full-scale build?",
        answer:
            "No. Some projects begin with a smaller, focused version to validate requirements before moving into a larger rollout.",
    },
    {
        question:
            "How involved does our internal team need to be during development?",
        answer:
            "That depends on the project, but regular collaboration helps. We work closely with internal teams to keep priorities, workflows, and technical decisions aligned.",
    },
    {
        question:
            "Can you support enterprise-grade systems with multiple users and workflows?",
        answer:
            "Yes. We work on systems that support complex operations, multiple user roles, and integrations across business-critical tools.",
    },
];

export default function FAQ() {
    return (
        <section className='padding-section-large faq-section'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Frequently Asked <span className="text-gradient-1">Questions</span></h2>
                    </Col>
                </Row>
                <Accordion defaultActiveKey="0" flush>
                    {faqData.map((faq, index) => (
                        <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="faq-item"
                        >
                            <Accordion.Header>
                                {faq.question}
                            </Accordion.Header>
                            <Accordion.Body>
                                {faq.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </section>
    );
}